module.exports = __webpack_public_path__ + "img/authen.ca6dc2a2.png";